export default __webpack_public_path__ + "static/media/DAT.b0e5182c.png";